module.exports = __webpack_public_path__ + "static/img/7.0f6db17.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/7.jpg
// module id = 0fx1
// module chunks = 1